module.exports = __webpack_public_path__ + "static/media/homeIcon.36992d88.png";